<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page_7"><span class="txit">To our parents:</span></a></p><a id="page_7">
<p class="ded1"><span class="txit">Merle and Kathleen Wert</span></p>
</a><p class="dedr"><a id="page_7"><span class="txit">Ralph and Ethel Long</span></a><a id="page_8"></a></p><a id="page_8">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?6da8e3f6